import { createAction, props } from '@ngrx/store';

export const GetLocations = createAction('[GetLocations] GetLocations', props<{ customerId: string }>());

export const GetLocationsSuccess = createAction('[GetLocations] GetLocations Success', props<{ data: any }>());

export const GetLocationsFailure = createAction('[GetLocations] GetLocations Failure', props<{ error: any }>());
